import { render, staticRenderFns } from "./counterpartiesActive.vue?vue&type=template&id=54aca8fd"
import script from "./counterpartiesActive.vue?vue&type=script&lang=js"
export * from "./counterpartiesActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports